import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { errorMessage } from "@/lib/api";
import { Wordmark } from "@/components/common/ui";
import { IMAGES } from "@/lib/site";

export default function AdminLoginPage() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  if (["admin", "agent"].includes(user?.role)) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const u = await login(email, password);
      if (["admin", "agent"].includes(u?.role)) navigate("/admin");
      else setError("This login is for the 757 Realty team. Buyer accounts sign in from the main site.");
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid min-h-screen lg:grid-cols-2" data-testid="admin-login-page">
      <div className="relative hidden bg-neutral-900 lg:block">
        <img src={IMAGES.carrier} alt="" className="absolute inset-0 h-full w-full object-cover opacity-70" />
        <div className="absolute bottom-10 left-10 text-white"><Wordmark light /><p className="mt-4 max-w-sm text-white/80">A private workspace for website enquiries and your 757 Realty team roster.</p></div>
      </div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm space-y-5" data-testid="admin-login-form">
          <Link to="/" className="lg:hidden"><Wordmark /></Link>
          <div><h1 className="text-3xl font-normal">Team login</h1><p className="mt-1 text-[15px] text-neutral-500">Sign in to manage enquiries and your team roster.</p></div>
          <div className="space-y-1.5"><Label htmlFor="email">Email</Label><Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="h-11" data-testid="admin-login-email" autoComplete="username" /></div>
          <div className="space-y-1.5"><Label htmlFor="password">Password</Label><Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="h-11" data-testid="admin-login-password" autoComplete="current-password" /></div>
          {error && <p className="rounded-md bg-red-50 p-3 text-[14px] text-red-700" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={busy} className="flex h-12 w-full items-center justify-center gap-2 rounded-full bg-ink text-white hover:bg-neutral-800 disabled:opacity-60" data-testid="admin-login-submit">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
          </button>
          <Link to="/" className="block text-center text-[14px] text-neutral-500 hover:text-ink" data-testid="admin-login-back">Back to website</Link>
        </form>
      </div>
    </div>
  );
}
